import {HRConfig} from "./HRConfig";
import {HRConfigAccess} from "./HRConfigAccess";
import {HRConfigEnterprise} from "./HRConfigEnterprise";
import {HRConfigParam} from "./HRConfigParam";
import {HRConfigRight} from "./HRConfigRight";
import {JSonSerializer} from "../JSonSerializer";
import {BankTypeUser} from "../../home/bank/model/BankTypeUser";
import {Utils} from "../Utils";
import {HRParamType} from "./HRParamType";
import {HRAbility} from "../../home/performance/model/HRAbility";
import {HRPerformanceTemplate} from "../../home/performance/model/HRPerformanceTemplate";
import {HRCompetency} from "../../home/performance/model/HRCompetency";
import {HRKeyResponsibilityArea} from "../../home/performance/model/HRKeyResponsibilityArea";
import {HRGoalAggregation} from "../../home/performance/model/HRGoalAggregation";
import {HRKeyResponsibilityAreaAggregation} from "../../home/performance/model/HRKeyResponsibilityAreaAggregation";
import {HRCareerAggregation} from "../../home/learning/model/HRCareerAggregation";

export class HRConfigAggregation{

  config = new HRConfig();
  accesses = new Array<HRConfigAccess>();
  enterprises = new Array<HRConfigEnterprise>();
  params = new Array<HRConfigParam>();
  rights = new Array<HRConfigRight>();
  abilities = new Array<HRAbility>();
  competencies = new Array<HRCompetency>();
  // kras = new Array<HRKeyResponsibilityArea>();
  kras = new Array<HRKeyResponsibilityAreaAggregation>();
  careers = new Array<HRCareerAggregation>();

  goals = new Array<HRGoalAggregation>();
  performanceTemplates = new Array<HRPerformanceTemplate>();

  public retrieveParamsOfType(type:HRParamType){
    let res = new Array<HRConfigParam>();
    if (type && this.params){
      for (const param of this.params){
        if (type.code === param.paramType.code){
          res.push(param);
        }
      }
    }
    res = res.sort((a,b)=>{
       let tmp = 0;
       // tmp = Utils.sortAny(a.displayOrder,b.displayOrder);
       if (tmp===0){
         if (a.displayOrder<b.displayOrder){
           tmp = -1;
         }else if (a.displayOrder>b.displayOrder){
           tmp = 1;
         }
       }
       if (tmp===0){
         tmp = Utils.sortStrings(a.value,b.value);
       }
       return tmp;
    });
    console.log('DisplayOrder, Value');
    for (const bean of res){
      console.log(bean.displayOrder + ', ' + bean.value);
    }

    return res;
  }



  public addEnterprise(enterpriseId: number, name:string): HRConfigEnterprise{
    let found = false;
    if (this.enterprises){
      for (const access of this.enterprises){
        if (access.enterpriseId === enterpriseId){
          found = true;
          break;
        }
      }
    }
    if (found===false){
      const toAdd = new HRConfigEnterprise();
      toAdd.enterpriseId = enterpriseId;
      toAdd.hrConfigId = this.config.id;
      toAdd.active = true;
      toAdd.enterpriseName = name;
      this.enterprises.push(toAdd);
      return toAdd;
    }
    return null;
  }

  public addEmployee(employeeId: string, fullName:string): HRConfigAccess{
    let found = false;
       if (this.accesses){
         for (const access of this.accesses){
           if (access.employeeId === employeeId){
             found = true;
             break;
           }
         }
       }
       if (found===false){
         const toAdd = new HRConfigAccess();
         toAdd.employeeId = employeeId;
         toAdd.hrConfigId = this.config.id;
         toAdd.active = true;
         toAdd.fullName = fullName;
         this.accesses.push(toAdd);
         return toAdd;
       }
       return null;
  }

  public retrieveRightsByEmployeeId(employeeId: string){
    const res = new Array<HRConfigRight>();
    if (this.rights){
      for (const right of this.rights){
        if (employeeId === right.employeeId){
          res.push(right);
        }
      }

    }
    return res;
  }



  _createFromArray(propertyName: string, data: any) {
    const serializer = new JSonSerializer();
    if ('accesses' === propertyName) {
      for (const bean of <HRConfigAccess[]> data) {
        const tmp = new HRConfigAccess();
        serializer.deserialize(bean, tmp);
        this.accesses.push(tmp);
      }
    }
    if ('enterprises' === propertyName) {
      for (const bean of <HRConfigEnterprise[]> data) {
        const tmp = new HRConfigEnterprise();
        serializer.deserialize(bean, tmp);
        this.enterprises.push(tmp);
      }
    }
    if ('params' === propertyName) {
      for (const bean of <HRConfigParam[]> data) {
        const tmp = new HRConfigParam();
        serializer.deserialize(bean, tmp);
        this.params.push(tmp);
      }
    }
    if ('rights' === propertyName) {
      for (const bean of <HRConfigRight[]> data) {
        const tmp = new HRConfigRight();
        serializer.deserialize(bean, tmp);
        this.rights.push(tmp);
      }
    }

    if ('abilities' === propertyName) {
      for (const bean of <HRAbility[]> data) {
        const tmp = new HRAbility();
        serializer.deserialize(bean, tmp);
        this.abilities.push(tmp);
      }
    }

    if ('competencies' === propertyName) {
      for (const bean of <HRCompetency[]> data) {
        const tmp = new HRCompetency();
        serializer.deserialize(bean, tmp);
        this.competencies.push(tmp);
      }
    }

    if ('kras' === propertyName) {
      for (const bean of <HRKeyResponsibilityAreaAggregation[]> data) {
        const tmp = new HRKeyResponsibilityAreaAggregation();
        serializer.deserialize(bean, tmp,false);//Units and Links might be empty
        this.kras.push(tmp);
      }
    }

    if ('goals' === propertyName) {
      for (const bean of <HRGoalAggregation[]> data) {
        const tmp = new HRGoalAggregation();
        serializer.deserialize(bean, tmp,false); //kraLinks might be empty
        this.goals.push(tmp);
      }
    }


    if ('performanceTemplates' === propertyName) {
      for (const bean of <HRPerformanceTemplate[]> data) {
        const tmp = new HRPerformanceTemplate();
        serializer.deserialize(bean, tmp);
        this.performanceTemplates.push(tmp);
      }
    }

    if ('careers' === propertyName) {
      for (const bean of <HRCareerAggregation[]> data) {
        const tmp = new HRCareerAggregation();
        serializer.deserialize(bean, tmp);
        this.careers.push(tmp);
      }
    }


  }



}
